
import {
    take, put, select, takeLatest
} from 'redux-saga/effects';
import {
    processUpdateCartData,
    RETRIEVED_UPDATE_CART_SUCCESS,
    UPDATE_CART_FAILED
} from 'capi/redux';
import {
    getPaidDigitalItems,
    getShippingGroups
} from '../item/itemSelectors';
import { logError } from '../utils/errorUtils';
import {
    egiftCardsSerializer,
    shippingGroupSerializer,
    paymentSerializer
} from '../payment/capiOrderV4ItemSerializer';
import {
    getConsumerFees,
    paymentFormValues
} from '../payment/paymentSelectors';
import {
    PROCESS_UPDATE_CART_API,
    updateCartRequestSuccess,
    updateCartRequestFailed
} from './cartModule';
import { getRequireRecipientEmailForPhysicalGift } from '../brand/brandSelectors';

export const defaultFailureResponse = {
    status: 402,
    statusText: 'Payment Required',
    data: {
        errorCode: 'PAYMENT_REQUIRED',
        fieldErrors: []
    }
};

export const parseErrorResponse = response => ({
    httpCode: response.status,
    httpMessage: response.statusText,
    capiCode: response.data.errorCode,
    fieldErrors: response.data.fieldErrors
});


export function* updateCartAPIWatcherSaga() {
    yield takeLatest(PROCESS_UPDATE_CART_API, function* updateCartAPISaga(action) {
        const { data } = action;
        const { orderNumber, checkoutRequestData } = data;

        
        const paymentFormData = yield select(paymentFormValues);
        const digitalItems = yield select(getPaidDigitalItems);
        const shippingGroups = yield select(getShippingGroups);
        const requireRecipientEmailForPhysicalGift = yield select(getRequireRecipientEmailForPhysicalGift);
        const fees = yield select(getConsumerFees);

        
        let senderEmail = '';
        let senderName = '';

        if (paymentFormData) {
            const serializedPayment = paymentSerializer(paymentFormData);
            senderEmail = serializedPayment.get('purchaserEmail') || '';
            const firstName = serializedPayment.get('purchaserFirstName') || '';
            const lastName = serializedPayment.get('purchaserLastName') || '';
            senderName = `${firstName} ${(lastName === 'LNU') ? '' : lastName}`.trim();
        }

        
        const egiftCards = egiftCardsSerializer(
            digitalItems,
            senderEmail,
            senderName,
            requireRecipientEmailForPhysicalGift,
            fees
        );

        
        const plasticItems = shippingGroups.map(group => shippingGroupSerializer(
            group,
            senderEmail,
            senderName,
            requireRecipientEmailForPhysicalGift,
            fees
        )).toList();

        
        const cartDataWithSerializedItems = checkoutRequestData.merge({
            egiftCards,
            shippingGroups: plasticItems
        });

        
        yield put(processUpdateCartData({
            orderNumber,
            checkout_request_data: cartDataWithSerializedItems.toJS()
        }));

        
        const result = yield take([
            RETRIEVED_UPDATE_CART_SUCCESS,
            UPDATE_CART_FAILED
        ]);
        switch (result.type) {
            case RETRIEVED_UPDATE_CART_SUCCESS:
                
                {
                    const updatedCartData = result.data;
                    yield put(updateCartRequestSuccess(updatedCartData));
                }
                break;
            case UPDATE_CART_FAILED:
                
                logError('Error on update-cart call. CAPI returned a request failure');
                yield put(updateCartRequestFailed(result.error));
                break;
            default:
                break;
        }
    });
}

export default updateCartAPIWatcherSaga;
